import { FC, useState } from "react";
import { useFormik } from "formik";
import { Box, Grid, TextField, InputLabel } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import useMutation from "../../../../../shared/components/hooks/useMutation";
import useQuery from "../../../../../shared/components/hooks/useQuery";
// import { SidebarContext } from "../../../../../contexts/SidebarContext";
import InputTextfield from "../../../../../shared/components/textField";
import { FormContainer } from "../../../../../shared/components/formContainer";
import { ViewContainer } from "../../../../../shared/components/viewContainer";
import SingleEntityContainer from "../../../../../shared/components/singleEntityContainer";
import { TitleBarProps } from "../../../../../shared/components/titleBar";

import { customizeValidationSchema } from "../variables/customSchema";
import { jobType } from "../../../../../shared/interfaces/job-type";
import ToggleSwitch from "../../../../../shared/components/switch";
import SingleEntityImageViewer from "../../../../../shared/components/singleEntityImageViewer";
import { getTextFields } from "../variables/textFields";
import { EditButton } from "../../../../../shared/components/editButton";
import { CloseButton } from "../../../../../shared/components/closeButton";
import { ProfileBorderBox } from "../../../../../shared/components/profileComponents";

const JobTypeEdit: FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loading, data, fetchData } = useQuery(`/job-type/${id}`, null);
  const { loading: apiLoading, modifyData } = useMutation();
  const [editStatus, setEditStatus] = useState(false);
  const jobTypeData: jobType = (data as any)?.data || {};
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  //Edit permission checking
  const entityPermissions: any = (data as any)?.entityPermissions;
  const editPermission = entityPermissions
    ? entityPermissions?.includes("Job Type-Update")
    : true;
  //End of edit permission checking

  const initialValues = {
    name: jobTypeData?.name,
    enabled: jobTypeData?.enabled ? true : false,
  };

  const jobTypeForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnBlur: true,

    validationSchema: customizeValidationSchema(),

    onSubmit: async (formData: any) => {
      let response;
      if (id) {
        const formDataJobType = new FormData();
        if (selectedFile) {
          formDataJobType.append("file", selectedFile);
        }
        formDataJobType.append("name", formData.name);
        formDataJobType.append("enabled", formData.enabled ? "true" : "false");
        response = await modifyData(
          `/job-type/${id}`,
          "put",
          formDataJobType,
          jobTypeForm
        );
      }
      if (response) {
        closeUserEdit();
      }
    },
  });

  const closeUserEdit = () => {
    fetchData();
    setEditStatus(false);
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    setSelectedFile(file);

    if (file) {
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setPreviewUrl(null);
    }

    jobTypeForm.setFieldValue("iconURL", file || "");
  };

  const editTitlebar: TitleBarProps = {
    headerTitle: "Job Type -  Edit",
    title: "Edit Job Type",
    buttonTitle: "Save",
    onClick: () => jobTypeForm.handleSubmit(),
    dirty: jobTypeForm.dirty,
    buttonLoading: apiLoading,
    editCloseIcon: {
      visible: true,
      onClick: () => closeUserEdit(),
    },
  };

  const viewTitleBar: TitleBarProps = {
    title: "Job Type Details",
    headerTitle: "Job Type Details",
  };
  const JobTypeEditFields = getTextFields(jobTypeData);

  const closeDetailsView = () => {
    navigate("/master-datas/job-types");
  };

  const jobTypeEditTooltipNode = (
    <>
      {editPermission && <EditButton onClick={() => setEditStatus(true)} />}
      <CloseButton onClick={() => closeDetailsView()} />
    </>
  );

  return (
    <>
      {editStatus && (
        <>
          <ProfileBorderBox>
            <FormContainer titleBar={editTitlebar}>
              <Box className="form-border-custom">
                <Grid
                  container
                  alignItems="stretch"
                  columnSpacing={4}
                  rowSpacing={2}
                >
                  <Grid item xs={12}>
                    <ToggleSwitch
                      status={jobTypeForm?.values?.enabled}
                      handleChange={() =>
                        jobTypeForm.setFieldValue(
                          "enabled",
                          !jobTypeForm?.values?.enabled
                        )
                      }
                    />
                  </Grid>
                  {JobTypeEditFields.map(
                    (field: any, index: number) =>
                      (field?.formField === undefined ||
                        field.formField === true) && (
                        <Grid item md={6} sm={6} xs={12} key={field.id}>
                          <InputTextfield
                            form={jobTypeForm}
                            fieldProps={field}
                            key={index}
                          />
                        </Grid>
                      )
                  )}
                  <Grid item md={6} sm={6} xs={6} key="jobType-iconURL">
                    <InputLabel>Icon</InputLabel>
                    <TextField
                      size="small"
                      fullWidth
                      id="outlined-basic"
                      type={"file"}
                      sx={{
                        marginTop: "1vh",
                        "& .MuiInputBase-root": {
                          height: "40px",
                          fontSize: "1rem",
                        },
                      }}
                      onChange={handleFileChange}
                    />
                  </Grid>
                  <Grid item md={3} sm={6} xs={6} key="jobType-iconPreview">
                    <div>
                      <SingleEntityImageViewer
                        src={previewUrl ? previewUrl : jobTypeData?.iconUrl}
                        alt="Event"
                      />
                    </div>
                  </Grid>
                </Grid>
              </Box>
            </FormContainer>
          </ProfileBorderBox>
        </>
      )}

      {!editStatus && (
        <ProfileBorderBox>
          <ViewContainer loading={loading} titleBar={viewTitleBar}>
            <div className="entity-container">
              <SingleEntityContainer
                entityFields={JobTypeEditFields}
                tooltips={jobTypeEditTooltipNode}
              ></SingleEntityContainer>
            </div>
          </ViewContainer>
        </ProfileBorderBox>
      )}
    </>
  );
};

export default JobTypeEdit;
